<template lang="pug">
  v-dialog(v-model="show" max-width="700" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    AddBoarderToDiscountGroupDialog(v-if="showBoarderDialog"
      :show="showBoarderDialog" @close="closeBoarderDialog"
      :selectedItem="selectedItem" @save="saveNewBoarderToGroup" :boarderList="filteredBoarderList" :discountBoarderList="discountBoarderList")
    v-card(height="500px" )
      v-card-title.px-0
        span.headline.pl-4 {{ $t('discountPage.pageTitle') }}
        v-tabs(
          v-model="tab"
          show-arrows
          next-icon="fas fa-arrow-right"
          prev-icon="fas fa-arrow-left")
          v-tab {{ $t('discountPage.settings') }}
          v-tab {{ $t('discountPage.boarderList') }}
      v-card-text.pa-0
        v-tabs-items(v-model="tab")
          v-tab-item
            v-card-text
              v-form(ref="form" v-model="isFormValid" :lazy-validation="true" :disabled="isSaveInProgress")
                v-row.ma-0
                  v-col(cols="12" md="6")
                    v-text-field(:label="`${$t('discountPage.nameLabel')}`" v-model="selectedItem.title" outlined disabled)
                  v-col(cols="12" md="6")
                    v-text-field(:label="`${$t('discountPage.valueLabel')}`" v-model="selectedItem.value" outlined disabled)

          v-tab-item
            v-row.ma-0
              v-col(cols="12")
                v-btn(color="primary" @click="addNewBoarderToDiscountGroupDialogClick" ) {{ $t('discountPage.addNewBoarderToGroupButtonLabel') }}
              v-col(cols="12" )
                v-list(dense)
                  v-list-item.ma-0.pa-0(v-for="(item,idx) in discountBoarderList" :key="idx")
                    v-row.ma-0(no-gutters)
                      v-col.text-start(cols="1") {{idx+1}}.
                      v-col.text-start(cols="4") {{item.person.firstName}} {{item.person.familyName}}
                      v-col.text-start(cols="2" v-for="(i, idx) in item.boarderGroupCollection" :key="idx") {{i.name}}
                      v-col.text-start(cols="4") {{item.customer.name}}
                      v-col.text-end.pa-0.pb-2(cols="1")
                        v-icon.pb-1(small @click="removeBoarderFromGroup(idx)") fas fa-trash
      v-divider
      v-card-actions.justify-end
        v-btn(@click="onCloseButtonClick" text :disabled="saveInProgress" ) {{ $t('buttons.closeButtonLabel') }}
        v-btn( color="primary" @click="onSaveButtonClick" :loading="saveInProgress" :disabled="saveInProgress || !formIsValid") {{ $t('buttons.saveButtonLabel') }}

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import AddBoarderToDiscountGroupDialog from "@/components/AddBoarderToDiscountGroupDialog.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {BOARDER_FETCH_LIST} from "@/store/action-types";
import Boarder from "@/model/boarder/Boarder";
import {indexOf} from "lodash";
import Discount from "@/model/Discount";

@Component({
  components: {
    AddBoarderToDiscountGroupDialog
  }
})
export default class DiscountDetailDialog extends Vue {
  $refs!: {
    form: Vue & { validate: () => boolean }
  }


  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: false}) readonly selectedItem!: Discount

  private saveInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private formIsValid: boolean = true
  private tab: number | null = null
  private isSaveInProgress: boolean = false
  private isFormValid: boolean = false
  private showBoarderDialog: boolean = false
  private piniaStore = usePiniaStore()
  private discountBoarderList: Boarder[] = []
  private id: any | null = null
  private boarderList: Boarder[] = []

  get filteredBoarderList (): Boarder[] {
    return this.boarderList.filter((item: Boarder) => !this.discountBoarderList.includes(item))
  }

  getBoarder (): void {
    let data: number[] = []
    let test: string = '/api/food-ordering/boarder/'
    this.selectedItem.targetBoarders.forEach((item: string) => {
      if(item.includes(test)) {
        this.id = item.slice(27)
        data.push(parseInt(this.id))
      }
    })
     data.map((i: number) => {
      this.boarderList.filter((a: Boarder) => {
        if(i === a.id){
          this.discountBoarderList.push(a)
        }

      })
    })
  }

  removeBoarderFromGroup (index: number) {
    this.discountBoarderList.splice(index,1)
    let id: string = ''
    let payload: any[] = []
    if(this.discountBoarderList.length > 0) {
      this.discountBoarderList.forEach((item: Boarder) => {
        const data = `/api/food-ordering/boarder/${item.id}`
        id = this.selectedItem.id
        payload.push(data)
      })
    } else {
      id = this.selectedItem.id
    }


    this.saveNewBoarderToGroup(payload,id, false)
  }

  addNewBoarderToDiscountGroupDialogClick () {
    this.showBoarderDialog = true
  }

  closeBoarderDialog () {
    this.showBoarderDialog = false
  }

  onCloseButtonClick () {
    this.$emit('close')
  }

  onSaveButtonClick(): void {

  }

  async saveNewBoarderToGroup (payload: number[], id: string, closeDialog: boolean):Promise<any> {
    this.saveInProgress = true
    try {
      const response =  await this.piniaStore.updateSelectedDiscountGroup(payload, id)
      this.saveInProgress = false

      if(closeDialog){
        this.$emit('fetchData')
        this.$emit('close')
      }


    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('discountPage.errorSaveMessage').toString()
    } finally {

    }
  }

  async fetchData ():Promise<void> {
    try {
      this.boarderList = await this.$store.dispatch(BOARDER_FETCH_LIST)
      this.getBoarder()
    } catch (e) {
    }
  }

  mounted(): void {
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>

</style>